import { NoteMetadata } from '../../models/notes/Notes'
import { PiiScrubRule, scrubSchemaPropertiesPII } from '../common/utils/scrubMetadataPII'

const FLEXIBLE_NOTE_PII_SCRUB_RULES: PiiScrubRule[] = [
  { field: 'attendance', remove: ['enumNames'] },
  { field: 'changeReason', remove: ['enumNames'] },
  { field: 'technicalIssuesCancelSelection', remove: ['enumNames'] },
  { field: 'guardianConsent', remove: ['enumNames'] },
  { field: 'approachingSpecialityCare', remove: ['content'] },
  { field: 'preAuthInfo', remove: ['content'] },
]

export const FLEXIBLE_NOTE_PII_FIELDS = FLEXIBLE_NOTE_PII_SCRUB_RULES.map(({ field }) => field)

export const scrubFlexibleNotePII = (metadata: NoteMetadata): NoteMetadata => {
  if (!metadata.meta_data) return metadata

  return { ...metadata, meta_data: scrubSchemaPropertiesPII(metadata.meta_data, FLEXIBLE_NOTE_PII_SCRUB_RULES) }
}
